import client, { Response } from './client';
import { IPromoCode } from '../../types/coupon';

export type GetPromoCodeDetailsParams = {
  user_phone_number: null | string;
};

export const getPromoCodes = (
  storeId: string,
  params: { user_phone_number: string },
): Response<IPromoCode[]> => client.get(`/stores/${storeId}/promo-codes`, { params });

export const getPromoCodeDetails = (
  storeId: string,
  code: string,
  params: GetPromoCodeDetailsParams,
): Response<IPromoCode> => client.get(`/stores/${storeId}/promo-codes/${code}`, { params });
